import React from 'react'

import { Button, CircularProgress } from '@mui/material'

import { useCompanyAiEnrichment } from 'views/company/useCompanyAiEnrichment'

type CompanyAiEnrichButtonProps = {
  companyDomain: string
  companyName: string
  companyUuid: string
  companyCountry?: string
  onComplete?: (...args: any[]) => any
}

const CompanyAiEnrichButton = ({
  companyUuid,
  companyDomain,
  companyName,
  companyCountry,
  onComplete,
}: CompanyAiEnrichButtonProps) => {
  const { trigger, isCompanyEnriching, isTriggering } = useCompanyAiEnrichment(companyUuid, { onComplete, companyName })

  const isInProgress = isTriggering || isCompanyEnriching

  const handleClick = () => {
    ;(trigger as any)({ company_domain: companyDomain, company_name: companyName, country_code: companyCountry })
  }

  return (
    <Button color="primary" disabled={isInProgress} onClick={handleClick} variant="contained">
      {isInProgress ? (
        <>
          <CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} />
          AI Enriching...
        </>
      ) : (
        'AI Enrich'
      )}
    </Button>
  )
}

export default CompanyAiEnrichButton
